'use strict';

const Backbone = require('backbone');

const SidebarItemModel = Backbone.Model.extend({
    defaults: {
        active: false,
        view: null
    },

    getHeader: function() {
        return this.get('header');
    },

    getView: function() {
        return this.get('view');
    },

    isActive: function() {
        return this.get('active');
    },

    _setActive: function(active) {
        this.set({active: active});
    },

    activate: function() {
        if(this.isActive()) {
            return;
        }
        this._setActive(true);
        this.trigger('active', this);
    },

    deactivate: function() {
        if(!this.isActive()) {
            return;
        }
        this._setActive(false);
        this.trigger('inactive', this);
    },

    toggle: function() {
        if(this.isActive()) {
            this.deactivate();
        } else {
            this.activate();
        }
    }
});

module.exports = Backbone.Collection.extend({
    model: SidebarItemModel,
    getByName: function(name) {
        return this.find(item => item.get('name') == name);
    }
});




// WEBPACK FOOTER //
// ./common/ui/view/sidebar/collection.js